// extracted by mini-css-extract-plugin
module.exports = {"loader":"ButtonLoader_loader__1CfPG","draw-erase":"ButtonLoader_draw-erase__qdlfx"};